import m from '@bitstillery/mithril'
import {MithrilComponent} from '@bitstillery/mithril'
import {$t} from '@bitstillery/common/app'

import {$s} from '@/app'

export class PromotionTerms extends MithrilComponent {
    view(_vnode: m.Vnode) {
        return (
            <span
                className='c-promotion-terms'
                onclick={() => {
                    $s.promotion.terms.collapsed = !$s.promotion.terms.collapsed
                    void m.route.set('/my-portal/promotions')
                }}
            >
                {$t('promotions.terms.conditions')}
            </span>
        )
    }
}
